import { pluginFactories } from '@react-page/plugins-slate';
import React from 'react';
import Typography from '@mui/material/Typography';
import { lazyLoad } from '@react-page/editor';
export const getAlignmentFromElement = (el) => {
    var _a;
    const align = (_a = el === null || el === void 0 ? void 0 : el.style) === null || _a === void 0 ? void 0 : _a.textAlign;
    if (align) {
        return {
            align,
        };
    }
};
const paragraph = pluginFactories.createComponentPlugin({
    type: 'PARAGRAPH/PARAGRAPH',
    label: 'Paragraph',
    object: 'block',
    addToolbarButton: false,
    addHoverButton: false,
    deserialize: {
        tagName: 'p',
        getData: getAlignmentFromElement,
    },
    getStyle: ({ align }) => ({ textAlign: align }),
    Component: (props) => {
        return (
        // be sure to mixin attributes, this is required for slate
        React.createElement(Typography, Object.assign({ style: props.style }, props.attributes), props.children));
    },
});
const H1Icon = lazyLoad(() => import('@mui/icons-material/LooksOne'));
const H2Icon = lazyLoad(() => import('@mui/icons-material/LooksTwo'));
const H3Icon = lazyLoad(() => import('@mui/icons-material/Looks3'));
const H4Icon = lazyLoad(() => import('@mui/icons-material/Looks4'));
const H5Icon = lazyLoad(() => import('@mui/icons-material/Looks5'));
const H6Icon = lazyLoad(() => import('@mui/icons-material/Looks6'));
// eslint-disable-next-line @typescript-eslint/ban-types
function createHeadingsPlugin(def) {
    return pluginFactories.createComponentPlugin({
        type: def.type,
        hotKey: 'mod+' + def.level,
        replaceWithDefaultOnRemove: true,
        icon: def.icon,
        label: `Heading ${def.level}`,
        object: 'block',
        addHoverButton: false,
        addToolbarButton: true,
        deserialize: {
            tagName: 'h' + def.level,
            getData: getAlignmentFromElement,
        },
        getStyle: ({ align }) => ({ textAlign: align }),
        Component: (props) => {
            return (
            // be sure to mixin attributes, this is required for slate
            React.createElement(Typography, Object.assign({ variant: def.variant, style: props.style }, props.attributes), props.children));
        },
    });
}
const headings = {
    h1: createHeadingsPlugin({
        type: 'HEADINGS/HEADING-ONE',
        level: 1,
        variant: 'h1',
        icon: React.createElement(H1Icon, null),
    }),
    h2: createHeadingsPlugin({
        type: 'HEADINGS/HEADING-TWO',
        level: 2,
        variant: 'h2',
        icon: React.createElement(H2Icon, null),
    }),
    h3: createHeadingsPlugin({
        type: 'HEADINGS/HEADING-THREE',
        level: 3,
        variant: 'h3',
        icon: React.createElement(H3Icon, null),
    }),
    h4: createHeadingsPlugin({
        type: 'HEADINGS/HEADING-FOUR',
        level: 4,
        variant: 'h4',
        icon: React.createElement(H4Icon, null),
    }),
    h5: createHeadingsPlugin({
        type: 'HEADINGS/HEADING-FIVE',
        level: 5,
        variant: 'h5',
        icon: React.createElement(H5Icon, null),
    }),
    h6: createHeadingsPlugin({
        type: 'HEADINGS/HEADING-SIX',
        level: 6,
        variant: 'h6',
        icon: React.createElement(H6Icon, null),
    }),
};
export default {
    paragraph: paragraph,
    headings: headings,
};
//# sourceMappingURL=typographyPlugin.js.map